<template><div class="time-select">
  <select v-model="hour">
    <option v-for="h in hours" :key="'hour-'+h"
      :value="h" v-html="h < 10 ? `0${h}` : h" />
  </select>
  :
  <select v-model="minute">
    <option v-for="m in minutes" :key="'minute-'+m"
      :value="m" v-html="m < 10 ? `0${m}` : m" />
  </select>
</div></template>
<script>
import moment from 'moment'
export default {
  name: 'time-select',
  props: ['min','max','value'],
  data() {
    return this.parseValue(this.value)
  },
  computed: {
    hours() {
      let hh = []
      if (moment.isMoment(this.value)
          && !(moment.isMoment(this.min) && moment.isMoment(this.max) && this.min.isAfter(this.max))) {
        let left = (this.min && this.min.isSame(this.value, 'day')) ? this.min.hour() : 0,
          right = (this.max && this.max.isSame(this.value, 'day')) ? this.max.hour() : 23
        for (let h=left; h<=right; h++)
          hh.push(h)
      }
      return hh
    },
    minutes() {
      let mm = []
      if (moment.isMoment(this.value)
          && !(moment.isMoment(this.min) && moment.isMoment(this.max) && this.min.isAfter(this.max))) {
        let left = (this.min && this.min.isSame(this.value, 'hour')) ? this.min.minute() : 0,
          right = (this.max && this.max.isSame(this.value, 'hour')) ? this.max.minute() : 59
        for (let m=left; m<=right; m++)
          mm.push(m)
      }
      return mm
    },
  },
  watch: {
    value(nv,ov) { Object.assign(this, this.parseValue()) },
    hour(nv,ov) { this.updateDate('hour', nv) },
    minute(nv,ov) { this.updateDate('minute', nv) },
    hours(nv) {
      if (!nv.length) return
      if (this.hour < nv[0]) this.hour = nv[0]
      else if (this.hour > nv[nv.length-1]) this.hour = nv[nv.length-1]
    },
    minutes(nv) {
      if (!nv.length) return
      if (this.minute < nv[0]) this.minute = nv[0]
      else if (this.minute > nv[nv.length-1]) this.minute = nv[nv.length-1]
    },
  },
  methods: {
    parseValue(m) {
      return (
        moment.isMoment(this.value)
          ? { hour: this.value.hour(), minute: this.value.minute() }
          : { hour: null, minute: null }
      )
    },
    updateDate(attr, val) {
      if (!moment.isMoment(this.value)) return
      this.$emit('input', this.value.clone()[attr](val))
    },
  },
}
</script>
<style lang="scss">
</style>
